// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__1npWy","bg":"style_bg__2_29P","content":"style_content__34CFM","left":"style_left__3KhPw"};